"use client"

import { BundlePrice } from "~/components/ui/Product/ProductHeader/ProductDetails/BundlePrice"
import { objectValues } from "~/utils/object-values"
import type { BundlePriceWithVariantSwitchProps } from "~/app/[locale]/products/[slug]/_components/BundlePriceWithVariantSwitch"
import { useVariantSwitch } from "~/app/[locale]/products/[slug]/_hooks/use-variant-switch"

function ClientBundlePriceWithVariantSwitch({ productHeader }: BundlePriceWithVariantSwitchProps) {
  const { currentOptions } = useVariantSwitch({
    defaultOptions: objectValues(productHeader?.defaultBundleOptions),
  })

  return <BundlePrice productHeader={productHeader} currentOptions={currentOptions} />
}

export default ClientBundlePriceWithVariantSwitch
